import request from '@/utils/request'

/**
 * 发送手机验证码
 * @param {*} mobile 手机号码
 */
export function sendCode(mobile, verifyCode, actionName) {
  return request({
    url: '/SMS/SendCode',
    method: 'get',
    params: { mobile, verifyCode, actionName }
  })
}

/**
 * 生成图片验证码，返回图片base64
 * @param {*} mobile 手机号码
 */
export function verifyCodeImageBase64() {
  return request({
    url: '/Home/VerifyCodeImageBase64?v=' + Math.random(),
    method: 'get',
    params: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js